import styled from "styled-components";

export const EventsTimelineWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
